module.exports = __webpack_public_path__ + "media/svg/setting-864da399.svg";